import { render, staticRenderFns } from "./CompaniesFilterComponent.vue?vue&type=template&id=64f63605&"
import script from "./CompaniesFilterComponent.vue?vue&type=script&lang=js&"
export * from "./CompaniesFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports